import { render, staticRenderFns } from "./SignModule.vue?vue&type=template&id=38abafb1&scoped=true"
import script from "./SignModule.vue?vue&type=script&lang=js"
export * from "./SignModule.vue?vue&type=script&lang=js"
import style0 from "./SignModule.vue?vue&type=style&index=0&id=38abafb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38abafb1",
  null
  
)

export default component.exports